import { Box, List, ListItem, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'
import AvatarComponent from '../../components/avatar/AvatarComponent'
import UsersMenuPopup from '../../components/Popup/UsersMenuPopup'
import navigation from '../../config/navigation'
import { useSelector } from 'react-redux'
import { getCurrentUser } from '../../store/redux/reducers/currentUserSlice'
import { FullName, Row } from '../../store/types/utils/DataTableUtils'
import { extractUserData } from '../../store/utils/usersUtils'

interface UserTileProps {
  user: Row
  checkbox?: React.ReactNode
}

const UserTile = ({ user, checkbox }: UserTileProps) => {
  const navigate = useNavigate()
  const currentUser = useSelector(getCurrentUser)
  const navigateString = currentUser?.id !== user.id ? `${navigation.users}/${user.id}` : `${navigation.myProfile}`
  const userData = extractUserData(user)

  return (
    <Box justifyContent="space-between" alignItems="center">
      <Stack direction="column" justifyContent="space-between">
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" alignItems="center">
            {checkbox}
            <Box
              sx={{
                height: 'fit-content',
                border: '1px solid',
                borderRadius: 1,
                p: '5px',
                width: 'fit-content',
                borderColor: 'background.elevation8',
              }}
            >
              <Typography variant="body2" color="textSecondary">
                {t(`statuses.${user.employeeStatus.toLowerCase()}`)}
              </Typography>
            </Box>
          </Stack>
          <Box>
            <UsersMenuPopup user={userData} navigateString={navigateString} />
          </Box>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1} marginBottom="5px" marginLeft="2px">
          <AvatarComponent
            extension={userData.extension}
            avatar={userData.avatar}
            alt={`${user.firstName}-${user.lastName}-profile-picture`}
            size={36}
          />
          <Stack direction="column" justifyContent="space-between">
            <Typography variant="h6" sx={{ cursor: 'pointer' }} onClick={() => navigate(navigateString)}>
              {user.firstName} {user.lastName}
            </Typography>
            <Typography variant="subtitle2" color="textSecondary" flexWrap={'wrap'}>
              {user.email}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Stack direction="column" justifyContent="space-between" marginTop="8px" marginLeft="44px">
        <Box>
          {user.leaders && user.leaders.length > 1 && (
            <Box>
              <Typography variant="body2" color="textSecondary" fontWeight={580}>
                {t('page.users.filtering.leaders')}:
              </Typography>
              <List sx={{ py: '2px' }}>
                {user.leaders.map((leader: { firstName: string; lastName: string }, index: number) => (
                  <ListItem key={index} sx={{ py: '4px' }}>
                    <Typography variant="body2">- {`${leader.firstName} ${leader.lastName}`}</Typography>
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
          <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user?.phoneNumber}
          </Typography>
          {user.leaders && user.leaders.length === 1 && (
            <Box>
              <Stack direction="row" spacing={'5px'}>
                <Typography variant="body2" color="textSecondary" fontWeight={580}>
                  {t('page.users.filtering.leader')}:
                </Typography>
                <Typography variant="body2">
                  {user.leaders.map((leader: FullName) => leader.firstName + ' ' + leader.lastName)}
                </Typography>
              </Stack>
            </Box>
          )}
        </Box>
      </Stack>
    </Box>
  )
}

export default UserTile
